module.exports = __webpack_public_path__ + "static/media/wisp.321b1c4d.png";